import {combineReducers ,ReducersMapObject} from "redux";
import { connectRouter } from "connected-react-router";
import login, { IState as ILoginState } from "login/reducer";
import userform, { IState as IUserFormState } from "userform/reducer";
import documents, { IState as IDocumentsState } from "documents/reducer";
import consent, {IState as IConsentState} from "consent/reducer";
import insurance, {IState as IInsuranceState} from "insurance/reducer";
import eGold, {IState as IEGold} from "egold/reducer";
import loanApplication, {IState as ILoanApplicationState} from "loan-application/reducer";
import profileInfo, {IState as IProfileInfo} from "profile/reducer";
import loanDetails, {IState as ILoanDetailsState} from "Loans/reducer";
import incompleteInfoV2, { IState as IIncompleteInfoV2State } from "IncompleteInfoV2/reducer";
import kyc, {IState as IKycState} from "Kyc/reducer";

export interface IReduxState {
    login: ILoginState;
    router: any;
    userform: IUserFormState;
    documents: IDocumentsState;
    consent: IConsentState;
    insurance: IInsuranceState;
    eGold: IEGold;
    loanApplication: ILoanApplicationState;
    profileInfo: IProfileInfo;
    loanDetails: ILoanDetailsState;
    incompleteInfoV2: IIncompleteInfoV2State;
    kyc: IKycState;
}

export default (history) => combineReducers<IReduxState>({
    login,
    router: connectRouter(history),
    userform,
    documents,
    consent,
    insurance,
    eGold,
    loanApplication,
    profileInfo,
    loanDetails,
    incompleteInfoV2,
    kyc,
} as ReducersMapObject<IReduxState, any>);
